// Reveal-on-scroll observer
document.addEventListener('DOMContentLoaded', function () {
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
});

// Predictive search dropdown
(function() {
  var debounceTimer = null;
  var activeInput = null;
  var dropdown = null;
  var rafScheduled = false;

  function createDropdown() {
    if (dropdown) return dropdown;
    dropdown = document.createElement('div');
    dropdown.className = 'nv-predict';
    dropdown.setAttribute('role', 'listbox');
    document.body.appendChild(dropdown);
    return dropdown;
  }

  function positionDropdown(input) {
    if (!input || !dropdown) return;
    var form = input.closest('form') || input;
    var rect = form.getBoundingClientRect();
    dropdown.style.cssText =
      'position:absolute;' +
      'top:' + (rect.bottom + window.scrollY + 8) + 'px;' +
      'left:' + (rect.left + window.scrollX) + 'px;' +
      'width:' + rect.width + 'px;' +
      'z-index:200;';
  }

  function schedulePosition() {
    if (rafScheduled || !dropdown || !activeInput) return;
    if (!dropdown.classList.contains('is-open')) return;
    rafScheduled = true;
    requestAnimationFrame(function() {
      positionDropdown(activeInput);
      rafScheduled = false;
    });
  }

  function show() { if (dropdown) dropdown.classList.add('is-open'); }
  function hide() { if (dropdown) dropdown.classList.remove('is-open'); }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function(c) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }

  function renderLoading() {
    dropdown.innerHTML = '<div class="nv-predict__loading">Buscando…</div>';
  }

  function renderResults(query, products) {
    if (!products || products.length === 0) {
      dropdown.innerHTML =
        '<div class="nv-predict__empty">' +
          '<p>No encontramos productos para "' + escapeHtml(query) + '"</p>' +
          '<a href="/search?q=' + encodeURIComponent(query) + '">Ver búsqueda completa →</a>' +
        '</div>';
      return;
    }
    var items = products.map(function(p) {
      var img = p.image || (p.featured_image && p.featured_image.url) || '';
      return '<a href="' + p.url + '" class="nv-predict__item">' +
        '<div class="nv-predict__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" decoding="async" width="56" height="56">' : '') + '</div>' +
        '<div class="nv-predict__info">' +
          '<div class="nv-predict__name">' + escapeHtml(p.title) + '</div>' +
          '<div class="nv-predict__price">' + (p.price || '') + '</div>' +
        '</div>' +
      '</a>';
    }).join('');
    dropdown.innerHTML =
      '<div class="nv-predict__list">' + items + '</div>' +
      '<a href="/search?q=' + encodeURIComponent(query) + '" class="nv-predict__all">' +
        'Ver todos los resultados' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg>' +
      '</a>';
  }

  function fetchSuggestions(query) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data && data.resources && data.resources.results && data.resources.results.products) {
          return data.resources.results.products;
        }
        return [];
      });
  }

  function handleInput(input) {
    var value = input.value.trim();
    if (value.length < 2) { hide(); return; }
    activeInput = input;
    createDropdown();
    positionDropdown(input);
    renderLoading();
    show();
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      fetchSuggestions(value).then(function(products) {
        if (activeInput !== input) return;
        if (input.value.trim() !== value) return;
        renderResults(value, products);
      }).catch(function() { hide(); });
    }, 250);
  }

  function attach() {
    document.querySelectorAll('input[type="search"][name="q"]').forEach(function(input) {
      if (input.dataset.predictInit) return;
      input.dataset.predictInit = '1';
      input.setAttribute('autocomplete', 'off');
      input.addEventListener('input', function() { handleInput(input); });
      input.addEventListener('focus', function() {
        if (input.value.trim().length >= 2) handleInput(input);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }

  document.addEventListener('click', function(e) {
    if (!dropdown) return;
    if (dropdown.contains(e.target)) return;
    if (e.target.matches && e.target.matches('input[type="search"][name="q"]')) return;
    hide();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') hide();
  });

  window.addEventListener('scroll', schedulePosition, { passive: true });
  window.addEventListener('resize', schedulePosition, { passive: true });
})();